import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Container,
  Grid,
  Header,
  Message,
  Button,
  Popup,
} from "semantic-ui-react";
import WeededDocumentList from "@modules/Document/backoffice/WeededDocumentList/WeededDocumentList";
import { BackOfficeRoutes } from "@routes/urls";
import { Link } from "react-router-dom";

export class WeededDocuments extends Component {
  render() {
    return (
      <Container fluid>
        <Header as="h2">Document Weeding Management</Header>

        <Grid>
          <Grid.Row>
            <Grid.Column width={16}>
              <Message>
                <Message.Header>About Document Weeding</Message.Header>
                <p>
                  This interface allows you to manage documents that have been
                  weeded out from the catalog. You can restore documents back to
                  the catalog or permanently delete them.
                </p>
              </Message>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={16}>
              <Popup
                content="Return to documents list"
                position="right center"
                trigger={
                  <Button
                    className="back-to-documents"
                    primary
                    basic
                    as={Link}
                    to={BackOfficeRoutes.documentsList}
                    icon="arrow left"
                  />
                }
              />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={16}>
              <WeededDocumentList />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default connect()(WeededDocuments);
